export default "__VITE_ASSET__CSL_He$F__"